import { graphql, useStaticQuery } from 'gatsby'
import React, { Fragment } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper'
import Heading from 'src/elements/typography/heading'
import Paragraph from 'src/elements/typography/paragraph'
import {
  FounderProfile,
  FounderProfileImage,
  FounderProfilesContainer,
  FoundersContainer,
  FoundersSectionWrapper, HiringCallToActionWrapper
} from './founders.styles'
import LinkSimple from 'elements/links/Link.simple'
import useOnMobile from 'src/hooks/useOnMobile';

const Founders = (): JSX.Element => {
  const isMobile = useOnMobile()

  const sliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 3,
    rows: 2,
    arrows: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  }

  const founderImages: any = useStaticQuery(graphql`{
    gina: contentfulAsset(contentful_id: {eq: "wLiyjVVblU0nrOzATsHbD"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
    tim: contentfulAsset(contentful_id: {eq: "6pQXcbVYei7ygkiVeRNmg5"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
    tom: contentfulAsset(contentful_id: {eq: "1wLP0q9jmZnwzYiYyhqqo7"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
    marny: contentfulAsset(contentful_id: {eq: "6RCOZTTUgtlo7sDRmqRC63"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
    jane: contentfulAsset(contentful_id: {eq: "Yl9C6ixJukr0qyocNRbN6"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
    parker: contentfulAsset(contentful_id: {eq: "2yQMZNS9OUnGgm6IPJYuTI"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
  }
  `)
  // TODO: founders should be gotten from Contentful as an array directly MNM-274
  const founders = [
    {
      id: 0, image: founderImages.gina.gatsbyImageData, name: 'Gina Bianchini', role: 'CEO & Co-Founder',
    },
    {
      id: 3, image: founderImages.marny.gatsbyImageData, name: 'Marny Sumrall', role: 'SVP of Business',
    },
    {
      id: 1, image: founderImages.tim.gatsbyImageData, name: 'Tim Herby', role: 'CTO & Co-Founder',
    },
    {
      id: 4, image: founderImages.jane.gatsbyImageData, name: 'Jane Stecyk', role: 'SVP of Marketing',
    },
    {
      id: 2, image: founderImages.tom.gatsbyImageData, name: 'Thomas Aaron', role: 'SVP Product & Co-Founder',
    },
    {
      id: 5, image: founderImages.parker.gatsbyImageData, name: 'Parker Vail', role: 'VP of Finance',
    }
  ]

  const foundersSliderOrder = [ ...founders ].sort((a, b) => a.id - b.id);

  return (
    <FoundersSectionWrapper>
      <FoundersContainer>
        <FadeInAnimationWrapper>
          <Heading
            text="Our Leadership Team"
            size="2.5em"
            sizeLg="2em"
            sizeSubLg="1.5em"
            align="center"
          />
        </FadeInAnimationWrapper>
        <FounderProfilesContainer>
          <Slider {...sliderSettings}>
            {
              isMobile ? foundersSliderOrder.map(({ image, name, role, id }) => (
                <Fragment key={id}>
                  <FounderProfile>
                    <FounderProfileImage>
                      <GatsbyImage
                        image={image}
                        alt={name}
                      />
                    </FounderProfileImage>
                    <Paragraph text={name} weight="normal" size="1.5em" sizeSubMd="1.2em" align="center" />
                    <Paragraph text={role} weight="light" size="1.5em" sizeSubMd="1.2em" align="center" />
                  </FounderProfile>
                </Fragment>
              )) : founders.map(({ image, name, role, id }) => (
                <Fragment key={id}>
                  <FounderProfile>
                    <FounderProfileImage>
                      <GatsbyImage
                        image={image}
                        alt={name}
                      />
                    </FounderProfileImage>
                    <Paragraph text={name} weight="normal" size="1.5em" sizeSubMd="1.2em" align="center" />
                    <Paragraph text={role} weight="light" size="1.5em" sizeSubMd="1.2em" align="center" />
                  </FounderProfile>
                </Fragment>
              ))
            }
          </Slider>
        </FounderProfilesContainer>
        <HiringCallToActionWrapper>
          <LinkSimple
            justify="center"
            icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.66 15.8" height="11px"><path d="M18.84,8.26A24.57,24.57,0,0,1,15,5.14,11.73,11.73,0,0,1,13.45,1.6l-2.9.8a15,15,0,0,0,2.17,4.65,11.65,11.65,0,0,0,.93,1H0v3H13.65a11.65,11.65,0,0,0-.93.95,15,15,0,0,0-2.17,4.65l2.9.8A12,12,0,0,1,15,13.86a24.73,24.73,0,0,1,3.82-3.12L20.66,9.5Z" transform="translate(0 -1.6)"></path></svg>}
            text="We’re hiring! See our open positions"
            url="/careers"
            smooth={false}
            color="main"
            size="1.4em"
            sizeSm="1em"
          />
        </HiringCallToActionWrapper>
      </FoundersContainer>
    </FoundersSectionWrapper>

  )
}

export default Founders
